export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13117.3d0a047d.jpg";